import React from 'react';
import Cookies from 'js-cookie';
import InstructionsDialog from '../../../InstructionsDialog';
import { PuzzleNames } from '../../../../utils/types';
import { DOMAIN } from '../../shared/utils';
import { UltrarubigramStore } from '../UltrarubigramStore';

const closeInstructions = () => {
  UltrarubigramStore.update(s => {
    s.instructionsAreOpen = false;
    s.isSoftPaused = false;
  });

  Cookies.set(`${PuzzleNames.Ultrarubigram}InstructionsDismissed`, 'true', {
    domain: DOMAIN,
    expires: 365,
  });
};

const Instructions = () => {
  const isOpen = UltrarubigramStore.useState(s => s.instructionsAreOpen);

  return (
    <InstructionsDialog isOpen={isOpen} onClose={closeInstructions}>
      <h1 className="instructionsTitle">How to Play the Ultrarubigram</h1>
      <div className="instructionsBody">
        <ul>
          <li>Rotate and flip until every row and column <span className="italicText">longer than two letters</span> spells a word from left-to-right and top-to-bottom.</li>
          <li>Flip the 3x3 subgrids by clicking their non-corner cells.</li>
          <li>Flip the 6x6 quadrants with the small tabs on their edges. A tab shared by two quadrants is split: each half flips the quadrant it sits in.</li>
          <li>Flip the 12x12 grids with the arrows around the outside, and rotate them with the shaded buttons at their centers.</li>
          <li>The button at the very center rotates the whole puzzle.</li>
          <li>Right-click any rotate button to rotate counterclockwise.</li>
          <li>No obscure words and mostly no proper names.</li>
        </ul>
      </div>
    </InstructionsDialog>
  );
};

export default Instructions;
